const state = { initialized: false, failed: false };

let _resolve;
const readyPromise = new Promise(resolve => { _resolve = resolve; });

export const setAdMobReady = () => {
  state.initialized = true;
  state.failed = false;
  _resolve(state);
};

export const setAdMobFailed = () => {
  state.initialized = true;
  state.failed = true;
  _resolve(state);
};

export const waitForAdMob = () => readyPromise;
export const isAdMobReady = () => state.initialized && !state.failed;
